
/** Класс формы на странице KWU */
class KwuForms {
    /**
     * Конструктор класса.
     *
     * @param {HTMLElement} el Элемент.
     */
    constructor(el) {
        if (window.config && window.config.recaptcha.public_key) {
            /* eslint-disable */
            grecaptcha.ready(function () {
                grecaptcha.execute(window.config.recaptcha.public_key, {action: "submit"})
                    .then(function (token) {
                        let captchaInput = el.querySelector("input[name='captcha_token']");
                        captchaInput.value = token;
                    });
            });
            /* eslint-enable */
        }
    }
}
window.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".js-kwu-form").forEach((item) => new KwuForms(item));
});
